import React from "react";

import { Achievements, Player } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../localization/localizationHelpers";
import { GameInformationSubFormsId } from "../../subForms/idXboxGameInformation/GameInformationPageConstants";
import { IdXboxIntroSubFormsId } from "../../constants/formConstants";
import { Card, CardProps } from "../Card/Card";
import * as cardStyles from "../Card/Card.module.css";

interface FormCardProps {
  /** ID of the current rendered form */
  cardId: string;
}

export const FormCard = ({ cardId: subFormId }: FormCardProps) => {
  const [
    // Account manager
    accountManagerSignedOutCardTitle,
    accountManagerSignedOutCardDescription,
    // Xbox
    contactDetailsCardTitle,
    contactDetailsCardDescription,
    studioInformationCardTitle,
    studioInformationCardDescription,
    // Game information
    conceptDetailsCardTitle,
    conceptDetailsCardDescription,
    gameExpectationCardTitle,
    gameExpectationCardDescription,
    xboxPlayAnywhereCardTitle,
    xboxPlayAnywhereCardDescription,
    pricingAndAvailabilityCardTitle,
    pricingAndAvailabilityCardDescription,
    ugcCardTitle,
    ugcCardDescription,
    idXboxIntroFormSummaryFormCardTitle,
    idXboxIntroFormSummaryFormCardDescription,
    idXboxGameInformationFormSummaryFormCardTitle,
    idXboxGameInformationFormSummaryFormCardDescription,
  ] = useStrings(
    "accountManagerSignedOutCardTitle",
    "accountManagerSignedOutCardDescription",
    "contactDetailsCardTitle",
    "contactDetailsCardDescription",
    "studioInformationCardTitle",
    "studioInformationCardDescription",
    "conceptDetailsCardTitle",
    "conceptDetailsCardDescription",
    "gameExpectationCardTitle",
    "gameExpectationCardDescription",
    "xboxPlayAnywhereCardTitle",
    "xboxPlayAnywhereCardDescription",
    "pricingAndAvailabilityCardTitle",
    "pricingAndAvailabilityCardDescription",
    "ugcCardTitle",
    "ugcCardDescription",
    "idXboxIntroFormSummaryFormCardTitle",
    "idXboxIntroFormSummaryFormCardDescription",
    "idXboxGameInformationFormSummaryFormCardTitle",
    "idXboxGameInformationFormSummaryFormCardDescription"
  );
  const cardStringsMap = new Map<string, CardProps>([
    [
      "AccountManagerSignedOut",
      {
        title: accountManagerSignedOutCardTitle,
        description: accountManagerSignedOutCardDescription,
        icon: Player,
      },
    ],
    [
      "IdXboxIntroFormSummary",
      {
        title: idXboxIntroFormSummaryFormCardTitle,
        description: idXboxIntroFormSummaryFormCardDescription,
      },
    ],
    [
      "IdXboxGameInformationFormSummary",
      {
        title: idXboxGameInformationFormSummaryFormCardTitle,
        description: idXboxGameInformationFormSummaryFormCardDescription,
      },
    ],
    [
      IdXboxIntroSubFormsId.ContactInformation,
      {
        title: contactDetailsCardTitle,
        description: contactDetailsCardDescription,
      },
    ],
    [
      IdXboxIntroSubFormsId.StudioInformation,
      {
        title: studioInformationCardTitle,
        description: studioInformationCardDescription,
      },
    ],
    [
      GameInformationSubFormsId.ConceptDetails,
      {
        title: conceptDetailsCardTitle,
        description: conceptDetailsCardDescription,
      },
    ],
    [
      "xboxPlayAnywhere",
      {
        title: xboxPlayAnywhereCardTitle,
        description: xboxPlayAnywhereCardDescription,
      },
    ],
    [
      GameInformationSubFormsId.GameExpectations,
      {
        title: gameExpectationCardTitle,
        description: gameExpectationCardDescription,
      },
    ],
    [
      GameInformationSubFormsId.PricingAndAvailability,
      {
        title: pricingAndAvailabilityCardTitle,
        description: pricingAndAvailabilityCardDescription,
      },
    ],
    [
      GameInformationSubFormsId.Ugc,
      {
        title: ugcCardTitle,
        description: ugcCardDescription,
      },
    ],
  ]);

  const cardValues = cardStringsMap.get(subFormId);
  if (cardValues == null) {
    return null;
  }

  return (
    <div className={cardStyles.cardContainer}>
      <Card
        icon={cardValues.icon ?? Achievements}
        title={cardValues.title}
        description={cardValues.description}
      />
    </div>
  );
};
